import { useRef } from 'react';
import classes from './addEditCVRecordWrapper.module.scss';
import ActionsButton from '../../buttons/ActionsButton/ActionsButton';
import { useOnClickOutside } from '../../../../utils/hooks';

function AddEditCVRecordWrapper(props) {
  const ref = useRef();

  const { confirmHandler, closeHandler, disableConfirmBtn, immediatelySaveData, children } = props;

  useOnClickOutside(ref, immediatelySaveData, 'react-datepicker-popper', 'react-datepicker__portal');

  return (
    <div ref={ref} className={classes.mainSection}>
      <div className={classes.actions}>
        <ActionsButton activityName="save" clickHandler={confirmHandler} disabled={disableConfirmBtn} />
        <ActionsButton activityName="cancel" clickHandler={closeHandler} />
      </div>
      {children}
    </div>
  );
}

export default AddEditCVRecordWrapper;
